common.View.create('vacancies::canvas.blocks.modules.vacancies.Block', {
    onDOMLoad() {
        this.initSwiper();
    },

    initSwiper() {
        let className = '.vacancySlider';
        let swiperEl = this.element.find(className);

        if (swiperEl.data('swiper-enabled') === false) {
            return;
        }

        new Swiper(className, {
            scrollbar: {
                el: '.swiper-scrollbar',
                hide: false,
            },
            slidesPerView: 1,
            spaceBetween: 10,
            breakpoints: {
                480: {
                    slidesPerView: 1.5,
                    spaceBetween: 20,
                },
                640: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                1280: {
                    slidesPerView: 2.5,
                    spaceBetween: 50,
                },
            },
            mousewheel: {
                releaseOnEdges: true,
                sensitivity: 1,
                invert: false,
            },
        });
    },
});
